module.exports = __webpack_public_path__ + "img/积分.b26d454c.png";